import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'u-turn-left', 'UTurnLeft', [["path",{"d":"M17 20v-11.5a4.5 4.5 0 1 0 -9 0v8.5"}],["path",{"d":"M11 14l-3 3l-3 -3"}]]);